import DestinationPage from '@/components/DestinationPage';

const Montalivet = () => {
  return (
    <DestinationPage
      title="Location de vélos à Montalivet"
      subtitle="Découvrez Montalivet à vélo : plages océanes, forêts et nature préservée"
      description="Montalivet, station balnéaire familiale du Médoc, offre un cadre naturel exceptionnel pour le vélo. Parcourez les pistes cyclables qui traversent la forêt de pins, longent les plages de l'Atlantique et relient les villages médocains. Une destination idéale pour des vacances nature à vélo."
      highlights={[
        "Pistes cyclables en forêt de pins",
        "Plages de sable fin et océan Atlantique",
        "Nature préservée et air marin",
        "Villages médocains authentiques",
        "Itinéraires familiaux sécurisés",
        "Ambiance station balnéaire conviviale"
      ]}
    />
  );
};

export default Montalivet;